module.exports = __webpack_public_path__ + "img/tone.1e42ba3f.webp";